import type { TranslationKey } from "src/types/translationKey";

export enum ProfileProgramMembership {
  MEDICARE = "MEDICARE",
  CDCDPP = "CDCDPP",
  ALLINONE_HEALTHCARE_CONCIERGE = "ALLINONE_HEALTHCARE_CONCIERGE",
  HEALTHY_WEIGHT_JOURNEY = "HEALTHY_WEIGHT_JOURNEY",
  DIABETES_AND_HEART_DISEASE_PREVENTION = "DIABETES_AND_HEART_DISEASE_PREVENTION",
  EVERYDAY_DIABETES_JOURNEY = "EVERYDAY_DIABETES_JOURNEY"
}

export enum KnownProgram {
  CDC_DPP = "cdcdpp",
  GENERAL_ALL = "general-all",
  DIABETES_PREVENTION = "diabetes-prevention",
  ONBOARDING = "onboarding",
  CARE = "care",
  MEAL_PLAN = "mealplan",
  PATH_HEALTHY_WEIGHT_HWJ_12W = "path-to-healthy-weight",
  BEHAVIORAL_HEALTH_SCREENING = "bh-screening",
  EDUCATION = "education",
  NUTRITION_JOURNEY = "nutrition-journey",
  MINDSET_JOURNEY = "mindset-journey",
  PHYSICAL_ACTIVITY_JOURNEY = "physical-activity-journey",
  EVERYDAY_DIABETES_JOURNEY = "everyday-diabetes-journey"
}

export enum KnownGroup {
  GLP1_CONTINUATION = "glp1-continuation",
  PRESCRIPTION = "prescription"
}

export const KnownProgramInfo: Record<
  KnownProgram,
  {
    title: TranslationKey;
    description: TranslationKey;
  } | null
> = {
  "general-all": {
    title: `program.title_${ProfileProgramMembership.ALLINONE_HEALTHCARE_CONCIERGE}`,
    description: "program_allInOneConcierge_description"
  },
  cdcdpp: {
    title: `program.title_${ProfileProgramMembership.CDCDPP}`,
    description: `program.description_${ProfileProgramMembership.CDCDPP}`
  },
  "diabetes-prevention": {
    title: `program.title_${ProfileProgramMembership.DIABETES_AND_HEART_DISEASE_PREVENTION}`,
    description: `program_diabetesPrevention_description`
  },
  "everyday-diabetes-journey": {
    title: `program.title_${ProfileProgramMembership.EVERYDAY_DIABETES_JOURNEY}`,
    description: `program.description_${ProfileProgramMembership.EVERYDAY_DIABETES_JOURNEY}`
  },
  onboarding: null,
  care: null,
  mealplan: null,
  "bh-screening": null,
  [KnownProgram.EDUCATION]: null,
  [KnownProgram.NUTRITION_JOURNEY]: null,
  [KnownProgram.MINDSET_JOURNEY]: null,
  [KnownProgram.PHYSICAL_ACTIVITY_JOURNEY]: null,
  [KnownProgram.PATH_HEALTHY_WEIGHT_HWJ_12W]: null
};
